import { AnimatePresence } from "framer-motion";
import { GuessRow } from "./GuessRow";
import type { GuessResult } from "@shared/types";

interface Props {
  guesses: GuessResult[];
  lastGuessId: string | null;
}

export function GuessFeed({ guesses, lastGuessId }: Props) {
  const sorted = [...guesses].sort((a, b) => b.similarity - a.similarity);
  if (sorted.length === 0) {
    return (
      <div className="text-center text-ink-400 py-16">
        Start typing your first guess — similarity will appear here.
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2">
      <AnimatePresence initial={false}>
        {sorted.map((g, i) => (
          <GuessRow key={g.id} guess={g} rank={i + 1} isLatest={g.id === lastGuessId} />
        ))}
      </AnimatePresence>
    </div>
  );
}
